var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-entry-table',{attrs:{"extended-filter-config-name":_vm.extendedFilterConfigName,"title":_vm.$t('global.models.entry.heading'),"subtitle":_vm.$t('global.models.entry.subheading')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }